export const SET_COLLAPSE = 'SET_COLLAPSE';
export const SET_PROJECTINFO = 'SET_PROJECTINFO';